export const dialogTitle = `custom-dialog-title`;
export const dialogDescription1 = `custom-dialog-description-1`;
export const dialogDescription2 = `custom-dialog-description-2`;
